// extracted by mini-css-extract-plugin
export default {"banner":"webpack-components-shared-FlashMessage-FlashMessage-module__banner"};